import * as React from 'react'
import { FunctionComponent } from 'react'
import { GoDash } from 'react-icons/go'

import { IoIosCheckmarkCircle } from 'react-icons/io'
interface SessionIndexProps {
  status: string
  id: string
  indexNumber: number
}
const SessionIndexComponent: FunctionComponent<SessionIndexProps> = ({
  status,
  id,
  indexNumber
}) => {
  return (
    <>
      <span
        data-qa-name='session-index-container'
        className={`flex justify-center items-center w-[3.5rem] h-[3.25rem] rounded-full cursor-default ${
          status === 'completed'
            ? ''
            : status === 'current'
              ? 'bg-alpha-black'
              : 'bg-transparent'
        }`}
      >
        {status === 'current' ? (
          <span
            data-qa-name={`session-index-${status}`}
            className='text-alpha-oatmeal font-bold text-xl'
          >
            {indexNumber}
          </span>
        ) : status === 'upcoming' ? (
          <span
            data-qa-name={`session-index-${status}`}
            className='text-alpha-black font-bold text-xl'
          >
            {indexNumber}
          </span>
        ) : status === 'skipped' ? (
          <span
            data-qa-name={`session-index-${status}`}
            className='text-alpha-black font-bold'
          >
            <GoDash data-qa-name='skipped-icon' />
          </span>
        ) : status === 'completed' ? (
          <IoIosCheckmarkCircle
            size={100}
            data-qa-name='completed-icon'
            fill='#00bba5'
          />
        ) : null}
      </span>
    </>
  )
}
export default SessionIndexComponent
